export enum AmmendOpportunityLoadingState {
    loadingOpportunity = 'Loading Opportunity...',
    savingChanges = 'Saving Changes...',
    submittingCompletion = 'Submitting Opportunity...',
    submittingReOpening = 'Re-Opening Opportunity...'
}